import { Banner } from '@cad-arc';

export function DexUserIdentificationBanner({
    onClose,
}: {
    onClose: () => void;
}): React.ReactElement {
    return (
        <Banner
            status="attention"
            title="Data Exchange Error: User Identification"
            description="The State User ID on your user profile is blank or expired. Contact an administrator to make sure your state authentication information is present and up-to-date."
            onClose={onClose}
        />
    );
}
